import { ApiConfig } from '@/config/api.config';

const fileToBase64 = (data: File | string): Promise<string> => {
	if (typeof data === 'string') return Promise.resolve(data);

	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.readAsDataURL(data);
		reader.onload = () => resolve(reader.result as string);
		reader.onerror = error => reject(error);
	});
};

const getImageUrl = (url?: string) => {
	return url?.startsWith('/')
	? `${ApiConfig.url}${url.slice(1)}`
	: url;
};

const getImageUrlFromFile = (data: File | string) => {
	if (data instanceof File) {
		return URL.createObjectURL(data);
	}

	return getImageUrl(data) ?? data;
};


export const ImagesHelper = {
	getImageUrl,
	getImageUrlFromFile,
	fileToBase64,
};